/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonPersonidResumeeExamsQueryResponse,
  GetApiV1PersonPersonidResumeeExamsPathParams,
  GetApiV1PersonPersonidResumeeExams400,
  GetApiV1PersonPersonidResumeeExams401,
  GetApiV1PersonPersonidResumeeExams500,
} from "../../types/personResumeeController/GetApiV1PersonPersonidResumeeExams.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonPersonidResumeeExams } from "../../clients/personResumeeController/getApiV1PersonPersonidResumeeExams.ts";

export const getApiV1PersonPersonidResumeeExamsQueryKey = (
  personId: GetApiV1PersonPersonidResumeeExamsPathParams["personId"],
) =>
  [
    {
      url: "/api/v1/person/:personId/resumee/exams",
      params: { personId: personId },
    },
  ] as const;

export type GetApiV1PersonPersonidResumeeExamsQueryKey = ReturnType<
  typeof getApiV1PersonPersonidResumeeExamsQueryKey
>;

export function getApiV1PersonPersonidResumeeExamsQueryOptions(
  personId: GetApiV1PersonPersonidResumeeExamsPathParams["personId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonPersonidResumeeExamsQueryKey(personId);
  return queryOptions<
    GetApiV1PersonPersonidResumeeExamsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonPersonidResumeeExams400
      | GetApiV1PersonPersonidResumeeExams401
      | GetApiV1PersonPersonidResumeeExams500
    >,
    GetApiV1PersonPersonidResumeeExamsQueryResponse,
    typeof queryKey
  >({
    enabled: !!personId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonPersonidResumeeExams(personId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados em comum e a lista de avaliações da pessoa **(Requer Authorization para autenticação)**
 * @summary Retorna aba de Avaliações do currículo (Requer Authorization para autenticação)
 * {@link /api/v1/person/:personId/resumee/exams}
 */
export function useGetApiV1PersonPersonidResumeeExams<
  TData = GetApiV1PersonPersonidResumeeExamsQueryResponse,
  TQueryData = GetApiV1PersonPersonidResumeeExamsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonPersonidResumeeExamsQueryKey,
>(
  personId: GetApiV1PersonPersonidResumeeExamsPathParams["personId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonPersonidResumeeExamsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonPersonidResumeeExams400
          | GetApiV1PersonPersonidResumeeExams401
          | GetApiV1PersonPersonidResumeeExams500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonPersonidResumeeExamsQueryKey(personId);

  const query = useQuery(
    {
      ...getApiV1PersonPersonidResumeeExamsQueryOptions(personId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonPersonidResumeeExams400
      | GetApiV1PersonPersonidResumeeExams401
      | GetApiV1PersonPersonidResumeeExams500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
